import React from "react";
//#region types
import { TableListProps } from "models/propTypes/inputPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import SearchContextProvider from "../../../search/context/contextProvider";
import ReportSearchInput from "../../../search/reportSearchInput";
import StyledButton from "../../../buttons/styledButton";
import TableListInner from "./tableListInner";
import useRememberedListPosition from "./useRememberedListPosition";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

function TableList<T extends Record<string, any>>(props: TableListProps<T>) {
  const {
    value,
    isReadOnly,
    onAddNewClick,
    hideAddNewButton,
    entityText,
    searchKeys,
    searchPlaceholder,
    moreButtons,
    rememberPositionKey,
    restorePosition,
  } = props;

  const { initialPage, initialSearchText, savePage, saveSearchText } = useRememberedListPosition(
    rememberPositionKey,
    restorePosition
  );

  const hasItems = value && value.length > 0;
  const showSearchBar = searchKeys ? searchKeys?.length > 0 : false;

  return (
    <SearchContextProvider initialSearchText={initialSearchText}>
      <Grid container className={cssExports.tableListContainer}>
        <Grid container className={cssExports.header} columnSpacing={2} direction="row">
          {hasItems ? (
            showSearchBar ? (
              <Grid item xs className={cssExports.search}>
                <ReportSearchInput placeholder={searchPlaceholder} />
              </Grid>
            ) : (
              <></>
            )
          ) : (
            <Grid item xs className={cssExports.emptyListMessage}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.NoEntitiesAdded, "", {
                entityName: entityText,
              })}
            </Grid>
          )}
          <Grid item container className={cssExports.headerButton} columnSpacing={2} direction="row">
            {moreButtons && moreButtons}
            {!isReadOnly && !hideAddNewButton && (
              <Grid item>
                <StyledButton size="sm" onClick={onAddNewClick}>
                  {`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.AddEntity)} ${entityText}`}
                </StyledButton>
              </Grid>
            )}
          </Grid>
        </Grid>
        {hasItems && (
          <TableListInner
            {...props}
            // Search filtering replaces the list on mount, which would otherwise reset the restored page.
            stayOnCurrentPage={props.stayOnCurrentPage || !!rememberPositionKey}
            initialPage={initialPage}
            onCurrentPageChange={rememberPositionKey ? savePage : undefined}
            onSearchTextChange={rememberPositionKey ? saveSearchText : undefined}
          ></TableListInner>
        )}
      </Grid>
    </SearchContextProvider>
  );
}

export default TableList;
